import { Navigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';

// helpers
// import { APICore } from '../helpers/api/apiCore';

// hooks
// import { useUser } from '../hooks';

type PrivateRouteProps = {
    component: React.ComponentType;
    roles?: string;
};

/**
 * Private Route forces the authorization before the route can be accessed
 * @param {*} param0
 * @returns
 */
const PrivateRoute = ({ component: RouteComponent, roles, ...rest }: PrivateRouteProps) => {
    let location = useLocation();
    // const [loggedInUser] = useUser();
    const user = useSelector((state: any) => state.useAuth.auth.user);

    // const api = new APICore();
    // console.log('useUser....', useUser);
    /**
     * not logged in so redirect to login page with the return url
     */
    // if (api.isUserAuthenticated() === false) {
    //     return <Navigate to={'/auth/login'} state={{ from: location }} replace />;
    // }

    // if user doesn't exist redirect them to login page
    if (!user) {
        return <Navigate to={'/auth/login'} state={{ from: location }} replace />;
    }

    // check if route is restricted by role
    // if (roles && roles.indexOf(loggedInUser.role) === -1) {
    //     // role not authorised so redirect to home page
    //     return <Navigate to={{ pathname: '/' }} />;
    // }

    return <RouteComponent />;
};

export default PrivateRoute;
